import ServiceHost from "../../di_service/service"
import { IDescriptor } from "../types"
import quickBooks from "./../../assets/logos/quick_books.png"
import QuickBooksConnector from "./connector"
import { IQuickBooksConnector } from "./types"


class QuickBooksDescriptor implements IDescriptor {
    public name: string = "QuickBooks"
    public id: string = "77"
    public color: string = "#2ca01c"
    public iconSrc: string = quickBooks
    // tslint:disable-next-line: max-line-length
    public description: string = "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc."
    public shortDescription: string = "Parse documents with one click"

    public createConnector(id: string): IQuickBooksConnector {
        return new QuickBooksConnector({ id, descriptor: this, serviceHost: ServiceHost })
    }
}

export default QuickBooksDescriptor
